import React, { useContext, useEffect, useState } from "react";
import "./LoginForm.css";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import FirstModal from "../Screens/CustomersPages/Password/FirstModal";
import {  ContextProvider } from "../Context";
import { primaryColor } from "../Screens/cardIssuing/cardIssuing";
import { Tooltip as ReactTooltip } from "react-tooltip";
import LoginPopUp from "./LoginPopUp";
import Joi from "joi";
import axios from "axios";
import { BASE_URL } from "../../config";
import { Loader } from "../Loader/Loader";
import { Modal } from "../Screens/Modal/Modal";
import { RemoveLocalStorage } from "../LocalStorage/LocalStorage";
import { GetLocalStorage } from "../LocalStorage/LocalStorage";

function LoginForm() {
  const Data = GetLocalStorage()


  const { setOpenTranspin,
    // setOpenResetTranspin,
    open2StepVerification,
      setOpen2StepVerification,
      openResetTranspin,
      twoStepVerificationSuccess,
      openTranspinSuccessful,
      open2StepOTP,
      openTranspin ,
      setUnverifiedSignupInfo,
    //  setLoginAuthorisation,
      
      setCustomerDetail,
      } = useContext(ContextProvider);



  const [usernameORemail, setUsernameORemail] = useState("username");
  const [loading, setLoading] = useState(false);
 

  // Check if login data exist ends here

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checkbox, setCheckbox] = useState(false);
 // const [cormfirmVirtualLoad, setConfirmVirtualLoad] = useState(false)
  const [passwordHidden, setPasswordHidden] = useState("password");
  const [isFocused, setIsFocused] = useState([]);
  const {showModal, setShowModal} = useContext(ContextProvider);

  const [toolTipWidth, setToolTipWidth] = useState("");
  const [toolTipOffset, setToolTipOffset] = useState("");
  const [errors, setErrors] = useState({});

  // const [redirect, setRedirect] = useState(false);
  // const navigate = useNavigate();
  
  useEffect(() => {
   if(open2StepVerification === false  &&
      openResetTranspin === false&&
      twoStepVerificationSuccess === false &&
      openTranspinSuccessful === false &&
      open2StepOTP === false &&
      openTranspin === false && localStorage.getItem("cxccxfd") ){
         RemoveLocalStorage();
      }

      if(localStorage.getItem("PasswordResetActive")){
     localStorage.removeItem("PasswordResetActive");
      }
      
    const handleResize = () => {
      const width = window.innerWidth;
      let newSize = "";
      let newOffset = "";

      if (width < 1024) {
        newSize = "96%";
        newOffset = 30;
      } else {
        newSize = "50%";
        newOffset = 50;
      }

      setToolTipWidth(newSize);
      setToolTipOffset(newOffset);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
 
   // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
  
  
    const handleResize = () => {
      const width = window.innerWidth;
      let newSize = "";
      let newOffset = "";

      if (width < 1024) {
        newSize = "96%";
        newOffset = 30;
      } else {
        newSize = "50%";
        newOffset = 50;
      }

      setToolTipWidth(newSize);
      setToolTipOffset(newOffset);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const usernameHandler = (e) => {
    setUsername(e.target.value);
  };
  const emailHandler = (e) => {
    setEmail(e.target.value);
  };
  const passwordHandler = (e) => {
    setPassword(e.target.value);
  };

  const checkBoxHandler = (e) => {
    setCheckbox(e.target.checked);
  };

  const handleFocus = (index) => {
    if (!isFocused.includes(index)) {
      setIsFocused([...isFocused, index]);
    }
  };

  const handleBlur = (index) => {
    if (isFocused.includes(index)) {
      setIsFocused(isFocused.filter((item) => item !== index));
    }
  };




const {setAlertCustom} = useContext(ContextProvider)
// ==========Login Handler===========
  const submitHandler = async (e) => {
    e.preventDefault();
if(!navigator.onLine) {
  setAlertCustom({
    message : "Check your internet connection",
    type : "error",
    show : true
  })
}


    // ========Login form validation starts here=======
    if (usernameORemail === "username" && navigator.onLine) {
      try {
        const schema = Joi.object({
          username: Joi.string()
            .pattern(new RegExp(/^[a-zA-Z0-9_]{3,30}$/))
            .required()
            .messages({ "string.pattern.base": "Invalid Username" }),
        });
       

        const { error } = schema.validate({ username });
       
        if (error) {
          // Handle validation error
          setErrors(
            error.details.reduce((acc, curr) => {
              acc[curr.path[0]] = curr.message;
              return acc;
            }, {})
          );
        } else {
          try {
          setLoading(true);
          const loginData = { username: username, password: password};
          const config = {
            headers: { "Content-Type": "application/json" },
            withCredentials : true
          };
        const response =   await axios
            .post(`${BASE_URL}/login`, loginData, config)
              if (response.status === 202 && response.headers.hasAuthorization) {
                 localStorage.setItem("xcss{}", true);
                setOpenTranspin(true);
              const customer  =  response?.data?.data?.customer;
             
             if(customer){
                   setCustomerDetail(customer);
               } 
     } else if(response.status === 200 ){
                  setOpen2StepVerification(true);
                   localStorage.setItem("xcss{}", true);
                  const customer  =  response?.data?.data?.customer;
            if(customer){
               setCustomerDetail(customer);
                  }} 
            } catch(error){
             if(error && error.response === undefined){
              setAlertCustom({
                message :  "Your internet connection is quite unstable.",
                type : "error",
                show : true
              })
              
          }else if(error && error?.response?.status === 500){
               setAlertCustom({
                message :  "Server error",
                type : "error",
                show : true
              })
              }else if (error && error?.response?.status === 404) {
                 setAlertCustom({
                message :  "User not found",
                type : "error",
                show : true
              })
              } else if (error?.response?.status === 401 || error?.response?.status === 400) {
                setAlertCustom({
                message :  "Incorrect Password: You are only allowed to try 5 times",
                type : "error",
                show : true
              })
              }else if (error &&  error?.response?.status === 403) {
               
                 if(error?.response?.data?.data?.data  === 'complete signup verification before continuing'){
           
             
                  setAlertCustom({
                message :  "SignUp Incomplete, for any help you can reach out to customer support.",
                type : "error",
                show : true
              })
            
                   }else {
           setAlertCustom({
                message :  "Your Account has been blocked, try again in the next one hour",
                type : "error",
                show : true
              })
            }
              }else {
               setAlertCustom({
                message :  "An unexpected error has occured.",
                type : "error",
                show : true
              })
              }
            };
          //if (checkbox === true) {
            // localStorage.setItem("aremxyPassword", JSON.stringify(password));
            // localStorage.setItem("aremxyUsername", JSON.stringify(username))
        
          //}
        }
      }finally {
        setLoading(false)
          }
    }

    if (usernameORemail === "email" && navigator.onLine ) {
    
        const schema = Joi.object({
          email: Joi.string()
            .pattern(new RegExp(/^\S+@\S+\.\S+$/))
            .required()
            .messages({ "string.pattern.base": "Invalid email" }),
        });
        const { error } = schema.validate({ email });
        if (error) {
          // Handle validation error
          setErrors(
            error.details.reduce((acc, curr) => {
              acc[curr.path[0]] = curr.message;
              return acc;
            }, {})
          );
        } else {
          setLoading(true);
          const loginData = { email: email, password: password };
          const config = {
            headers: { "Content-Type": "application/json" },
            withCredentials : true
          };
          try {
        const response =   await axios
            .post(`${BASE_URL}/login`, loginData, config)
        if (response.status === 202  && response?.headers?.hasAuthorization) {
           localStorage.setItem("xcss[]", true);
                setOpenTranspin(true);
           const customer = response?.data?.data?.customer;
              if(customer){
               setCustomerDetail(customer);
                  }
              }  else if(response.status === 200){
                 localStorage.setItem("xcss[]", true);
                setOpen2StepVerification(true);
             const customer  =  response?.data?.data?.customer;
             if(customer){
              setCustomerDetail(customer);
             
              }
         } 
            }catch(error){
       if(error && error.response === undefined){
                  setAlertCustom({
                message :  "Your internet connection is quite unstable.",
                type : "error",
                show : true
              })
          }else if(error?.response?.status=== 500){
                  setAlertCustom({
                message :  "Server error",
                type : "error",
                show : true
              })
              }else if(error?.response?.status === 404){
                   setAlertCustom({
                message :  "User not found",
                type : "error",
                show : true
              })
                   }
                   else if (error?.response?.status === 401 || error?.response?.status === 400) {
                  setAlertCustom({
                message :  "Incorrect Password: You are only allowed to try 5 times",
                type : "error",
                show : true
              })
                   } else if (error?.response?.status === 403) {
                     if(error?.response?.data?.data?.data  === 'complete signup verification before continuing'){
           
             
                  setAlertCustom({
                message :  "SignUp Incomplete, for any help you can reach out to customer support.",
                type : "error",
                show : true
              })
            
                   }else {
           setAlertCustom({
                message :  "Your Account has been blocked, try again in the next one hour",
                type : "error",
                show : true
              })
            }
            }else{
               setAlertCustom({
                message :  "An unexpected error has occured.",
                type : "error",
                show : true
              })
            }}finally{
       setLoading(false);
      }
    }
  
      }}



  
  return (
    <div
      className="relative overflow-hidden lg:top-[10%]  w-[100%] mb-[50%] xl:w-[85%] md:mx-[unset]  
       loginForm p-[25px] rounded-lg md:rounded-xl xl:rounded-3xl"
      style={{
        zIndex: 950,
      }}
    >
      {showModal && <FirstModal />}

      {<LoginPopUp />}
      <Link to="/">
        <img
          src="./Images/login/arpLogo.png"
          alt="logo"
          className="w-[36.51px] h-[17.73px] lg:w-[63.73px] lg:h-[30.94px]"
        />
      </Link>

      <div className="mt-[30px]">
        {/* Email starts here 268455*/}
        <form onSubmit={submitHandler}>
          <div className=" lg:px-[20%]">
            <div className=" mb-[14px] md:mb-[18px] lg:mb-[20px]">
              <p className="text-[14.93px] leading-[20px] md:text-[14.58px]
               lg:text-[17px] lg:leading-[21px] font-[600] w-[70%] mb-[7px] lg:mb-[10px] tracking-wider">
                <span
                  className={`${
                    usernameORemail === "username" ? "text-[#04177F]" : ""
                  }  cursor-pointer hover:text-gray-700`}
                  onClick={() => {
                    setUsernameORemail("username")
                    setErrors((obj)=>({
                      ...obj, email : ""
                    }))
                    }}
                >
                  Username
                </span>{" "}
                or{" "}
                <span
                  className={`${
                    usernameORemail === "email" ? "text-[#04177F]" : ""
                  }  cursor-pointer hover:text-gray-700`}
                  onClick={() =>{
                    setUsernameORemail("email");
                         setErrors((obj)=>({
                      ...obj, username : ""
                    }))
                  } }
                >
                  {" "}
                  Email
                </span>
              </p>
              <div
                className={`inputBoxShadow w-[100%] h-[50.75px] lg:h-[42px]
                   rounded flex items-center lg:hover:border-[#b3b3b3] lg:duration-300 
            ${
              isFocused.includes(1)
                ? "border-[#2684fe] border-2"
                : "border-[#cdcdcd] border-[1px]"
            }`}
                onFocus={() => handleFocus(1)}
                onBlur={() => handleBlur(1)}
              >
                <input
                  className="w-full h-full text-base lg:leading-[24px] leading-[18px] font-[500]
                  md:text-[14.58px] lg:text-[16px] px-[7.5px] md:px-[10px] rounded  text-[#403f3f] outline-none "
                  type="text"
                  value={usernameORemail === "username" ? username : email}
                  onChange={
                    usernameORemail === "username"
                      ? usernameHandler
                      : emailHandler
                  }
                  placeholder={
                    usernameORemail === "username"
                      ? "Enter username"
                      : "Enter email"
                  }
                  data-tooltip-id={
                    usernameORemail === "username" ? "username" : "email"
                  }
                  data-tooltip-content={
                    usernameORemail  === "username"
                      ? "Click on Email  to switch to email input" 
                      : "Click on Username to switch to username input"
                  }
                  data-tooltip-hidden={open2StepVerification === true ||
      openResetTranspin === true||
      twoStepVerificationSuccess === true||
      openTranspinSuccessful === true ||
    open2StepOTP === true||
      openTranspin === true }
                />

                <ReactTooltip
                  id={usernameORemail === "username" ? "username" : "email"}
                  type="success"
                  offset={toolTipOffset}
                  style={{
                    backgroundColor: "rgb(4,23,127)",
                    width: toolTipWidth,
                    textAlign: "center",
                    color: "#fff",
                    fontWeight: "bold",
                    letterSpacing: "1px",
                    fontSize: 12,
                    zIndex: 999,
                  }}
                />
              </div>
              {errors.username && (
                <div className="text-[12px] text-red-500
                 italic lg:text-[14px]">
                  {errors.username}
                </div>
              )}
              {errors.email && (
                <div className="text-[12px] text-red-500
                 italic lg:text-[14px]">
                  {errors.email}
                </div>
              )}
            
            </div>
            {/* Email ends here*/}
            {/* Password starts here 268455*/}
            <div className="mb-[14px] md:mb-[18px] lg:mb-[20px]">
              <p className="text-[12.93px] md:text-[14.58px]
               lg:text-[17px] leading-[16px] lg:leading-[21px] font-[600] w-[30%] mb-[7px] lg:mb-[10px] 
               tracking-wider">
                Password
              </p>
              <div
                className={`relative inputBoxShadow w-[100%] h-[50.75px] 
                  lg:h-[42px]  rounded  flex items-center
                   lg:hover:border-[#b3b3b3] lg:duration-300 
            ${
              isFocused.includes(2)
                ? "border-[#2684fe] border-2"
                : "border-[#cdcdcd] border-[1px]"
            }`}
                onFocus={() => handleFocus(2)}
                onBlur={() => handleBlur(2)}
              >
                {passwordHidden === "password" ? (
                  <img
                    src="./Images/login/eyeIcon2.png"
                    alt="icon"
                    className="absolute h-[20px] w-[20px] right-2 lg:w-[24px] cursor-pointer"
                    onClick={() => setPasswordHidden("text")}
                  />
                ) : (
                  <img
                    src="./Images/login/eyeIcon1.png"
                    alt="icon"
                    className="absolute right-2 w-[13.75px] lg:w-[24px] cursor-pointer"
                    onClick={() => setPasswordHidden("password")}
                  />
                )}
                <input
                  className={`w-full h-full ${
                    passwordHidden === "password"
                      ? "text-base leading-[18px] md:text-[14px] lg:text-[16px] lg:leading-[24px] font-[500]"
                      : "text-base leading-[18px] md:text-[14.58px] lg:text-[16px] lg:leading-[24px] font-[500]"
                  }  pl-[7.5px] md:pl-[10px] pr-[40px] md:pr-[50px] rounded  text-[#403f3f] outline-none`}
                  value={password}
                  onChange={passwordHandler}
                  required
                  type={passwordHidden}
                  // placeholder="Enter your first name"
                />
              </div>
            </div>
            {/* Password ends here*/}
            <p
              className="text-[rgb(4,23,127)] lg:text-[16px] md:text-[14.02px] text-[12.02px]
              font-semibold my-[25px] cursor-pointer tracking-wider"
              onClick={() =>{
                setShowModal(true)
              }}
            >
              Forgot password ?
            </p>
            <div className="flex items-center  mb-[30px]">
              <input
                type="checkbox"
                className="h-[25px] w-[25px]"
                name=""
                id=""
                checked={checkbox}
                onChange={checkBoxHandler}
              />
              <p className="ml-2 lg:text-[14px] md:text-[14.02px] 
               text-[13.02px] leading-[18px] font-[400]
               text-[#575757]  tracking-wider">
                Remember me next time!
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            {usernameORemail === "username" ? (
              <button
                type="submit"
                disabled={username === "" || password === "" ? true : false}
                className={` ${
                  username === "" || password === ""
                    ? "opacity-50 cursor-not-allowed"
                    : "opacity-[unset] cursor-pointer"
                } inline-flex justify-center items-center text-[#fff] text-center font-bold
                 w-full py-[20px] text-[14px] leading-[18px] rounded-[4px]
                  lg:text-[14px] lg:leading-[24px] lg:py-[5px]  lg:w-[140px] 
                   lg:rounded-[7px] lg:px-[37px]
`}
                style={{
                  backgroundColor: primaryColor,
                }}
              >
                <p> Sign in</p>
              </button>
            ) : (
              <button
                type="submit"
                disabled={ email === "" || password === "" ? true : false}
                className={` ${
                  email === "" || password === ""
                    ? "opacity-50 cursor-not-allowed"
                    : "opacity-[unset] cursor-pointer"
                } inline-flex justify-center items-center text-[#fff] text-center font-bold
                 w-full py-[20px] text-[14px] leading-[18px] rounded-[4px]
                  lg:text-[14px] lg:leading-[24px] lg:py-[5px]  lg:w-[140px] 
                   lg:rounded-[7px] lg:px-[37px]
`}
                style={{
                  backgroundColor: primaryColor,
                }}
              >
                <p> Sign in</p>
              </button>
            )}
          </div>
        </form>
        <p className="text-center text-[14px] font-semibold
           text-[#575757] my-4 cursor-pointer">
          -OR-
        </p>
        <div className="flex justify-center"
        >
          <div
           onClick ={()=> {
            alert("The use of Google as a third party authentication OAuth isn't available for now.")
          }} 
          //  onClick={() => setOpenResetTranspin(true)}
            className={`px-[5px] w-full lg:w-auto lg:px-[20px] py-[15px] 
              rounded  flex items-center justify-center
               lg:hover:border-[#b3b3b3] lg:duration-300 border-[#cdcdcd] border-[1px] cursor-pointer `}
          >
            <img
              src="./Images/login/Google.png"
              alt="google"
              className="w-[11.46px] lg:w-[20px] "
            />
            <p  onClick ={()=> {
            alert("The use of Google as a third party authentication OAuth isn't available for now.")
          }} 
            className="lg:text-[14px] md:text-[8.02px]
             text-[12.02px] leadig-[16px]  pl-4 font-semibold tracking-wider">
              Sign in with Google
            </p>
          </div>
        </div>
        <div className="flex justify-center mb-[20px] mt-[25px] lg:mb-[50px] lg:mt-[50px]">
          <p className="text-[12.17px] leading-[16px] 
          lg:text-[16px] lg:leading-[24px]
           font-semibold tracking-wider">
            Don’t have an account yet{" "}
          </p>
          <Link to="/signUp">
            <p className="pl-2 text-[12.17px] leading-[16px] 
          lg:text-[16px] lg:leading-[24px]
           font-semibold  text-[#04177F] cursor-pointer tracking-wider">
              ? Signup
            </p>
          </Link>
        </div>
      </div>
      {loading && (
        <Modal>
          <Loader />
        </Modal>
      )}
    </div>
  );
}

export default LoginForm;
